import { resetState } from '../../../../store/layout/layout-action';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  TemplateRef,
  type OnInit,
} from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { NgbModal, type NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ProfilesettingcardComponent } from '../profile-setting-card/profile-setting-card.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LogOutComponent } from '../log-out/log-out.component';
import { UpdatePasswordComponent } from '../update-password/update-password.component';
import { ProfileSettingModalComponent } from '../profile-setting-modal/profile-setting-modal.component';
import { GlobalService } from '../../services/common/global.service';
import { Router } from '@angular/router';
import { SwalalertService } from '../../services/swalalert/swalalert.service'; // Import service
import { LoaderService } from '../../services/loader/loader.service';
import { CookieService } from 'ngx-cookie-service';
import { profileSetting } from '../../common/profile-setting';
import { CommonModule } from '@angular/common';
import { session } from '../../common/session/session';
import { AvatarUtils } from '../../services/utils/avatar-utils';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { localStorageKeys } from '../../common/localstorages';
import { ToasterMessageService } from '../../services/topbar-toaster/toaster-message.service';
import { RouteUtils } from '../../services/utils/route-utils';
@Component({
  selector: 'app-right-sidebar',
  standalone: true,
  imports: [
    SimplebarAngularModule,
    CheckboxComponent,
    ProfilesettingcardComponent,
    UpdatePasswordComponent,
    LogOutComponent,
    ProfileSettingModalComponent,
    CommonModule,
  ],
  templateUrl: './right-sidebar.component.html',
  styleUrl: './right-sidebar.component.scss',

  styles: `
    :host {
      display: contents;
    }
  `,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RightSidebarComponent implements OnInit {
  router = inject(Router);
  offcanvas = inject(NgbActiveOffcanvas);
  store = inject(Store);
  private modalService = inject(NgbModal);
  private loadingService = inject(LoaderService);

  profileSettingData = profileSetting;
  userSettings!: any;
  layout: string = '';
  color!: string;
  topbar!: string;
  menuColor!: string;
  menuSize!: string;
  mode!: string;
  profile!: FormGroup;
  userType!: string;
  avatar: SafeHtml | null = null;
  isAvatar = false;
  private sanitizer = inject(DomSanitizer);

  constructor(
    public fb: FormBuilder,
    public globalService: GlobalService,
    private swalalertService: SwalalertService,
    private toasterService: ToasterMessageService,
    public cookieService: CookieService,
  ) {
    this.profile = this.fb.group({
      notification: '',
      message: '',
    });
    this.userType = this.globalService.getUserRole();
    this.userSettings = JSON.parse(this.globalService.getUserSettings());
    let thumbnail = this.userSettings.userInfo.imagePath;

    if (thumbnail == null || thumbnail == '' || thumbnail == 'undefined') {
      const avatarHtml = AvatarUtils.getInitialsWithColorForBar(
        this.userSettings.userInfo.first_name,
        this.userSettings.userInfo.last_name,
        false,
      );
      this.avatar = this.sanitizer.bypassSecurityTrustHtml(avatarHtml);
      this.isAvatar = true;
    }
  }
  ngOnInit(): void {
    this.store.select('layout').subscribe((data: any) => {
      this.layout = data.LAYOUT;
      this.color = data.LAYOUT_THEME;
      this.topbar = data.TOPBAR_COLOR;
      this.menuColor = data.MENU_COLOR;
      this.menuSize = data.MENU_SIZE;
      this.mode = data.LAYOUT_MODE;
    });
  }
  isCardVisible(item: any): boolean {
    return this.userSettings.userPermissions.some(
      (permission: any) =>
        permission.module_name === item.cardTitle && permission.is_assigned,
    );
  }
  getInitials(firstName: string, lastName: string): string {
    const first = firstName ? firstName.charAt(0).toUpperCase() : '';
    const last = lastName ? lastName.charAt(0).toUpperCase() : '';
    return first + last;
  }
  confirmAction() {
    this.swalalertService
      .showConfirmAlert(
        'Are you sure?',
        'You want to Log Out!',
        'Log Out!',
        'No, cancel!',
      )
      .then((confirmed) => {
        if (confirmed) {
          this.loadingService.showSpinner();
          this.cookieService.deleteAll();
          const user = localStorage.getItem('user');
          localStorage.removeItem(session.userLastRoute);
          localStorage.removeItem('userSettings');
          localStorage.removeItem('userRole');
          localStorage.removeItem(localStorageKeys.MENUS);
          this.toasterService.clearMessage();
          this.loadingService.stopSpinner();
          window.location.replace('');
          localStorage.clear();
          sessionStorage.clear();
          localStorage.setItem('user', user ? user : '');
          //this.swalalertService.showAlert('Deleted!', 'Your data has been deleted.', 'success');
        } else {
          // this.swalalertService.showAlert('Cancelled', 'Your data is safe.', 'info');
        }
      });
  }

  openModal(
    event: Event,
    content: TemplateRef<HTMLElement>,
    options: NgbModalOptions,
  ) {
    event.preventDefault();
    const modalOptions: NgbModalOptions = {
      ...options,
      backdrop: 'static',
      keyboard: false,
    };

    this.modalService.open(content, modalOptions);
  }

  cardEvent(item: any) {
    if (item?.externalUrl) {
      window.open(item.externalUrl, '_blank');
      return;
    }
    const value = item?.isActive ?? item;
    this.globalService.setUserRole(value);
    RouteUtils.initMenu(
      this.globalService.getUserRole(),
      JSON.parse(this.globalService.getUserSettings()),
    );
    this.router.navigateByUrl('/dashboard').then(() => {
      window.location.reload();
    });
  }

  handleModalDismiss() {
    this.modalService.dismissAll();
  }

  handleEmail(email: string) {
    // Logic to handle the email
  }
  // Reset Option
  reset() {
    this.store.dispatch(resetState());
  }
}
